<template>
  <div class="container">
    <div class="responsive-icon-container"
      @click="showResponsiveDropdown = !showResponsiveDropdown">
      <router-link to="/" class="site-mini-logo">
        <img alt="YouPaired Logo" src="../assets/logo_mini.png" />
      </router-link>
      <font-awesome-icon :icon="['fa', 'angle-down']" size="sm" class="responsive-angle-down-icon">
      </font-awesome-icon>
    </div>
    <router-link to="/" class="site-logo" v-ga="'headerClick'">
      <img alt="YouPaired Logo" src="../assets/logo.svg" />
    </router-link>
    <search-bar />
    <div class="authenticated-container" v-if="authenticated">
      <router-link class="header-tabs" to="/event/new/edit">
        <span>Create Event</span>
      </router-link>
      <div class="profile" @click="showProfileDropdown = !showProfileDropdown"
        v-ga="'profileClick'">
        <div class="profile-picture-container">
          <img v-if="profilePic" :src="profilePic" alt="Profile Picture"/>
          <font-awesome-icon v-else :icon="['fa', 'user-circle']" size="2x"
            :style="{ color: 'lightgray' }"/>
        </div>
        <portal to="dropdowns" v-if="showProfileDropdown">
          <profile-dropdown @hideDropdown="showProfileDropdown=false">
          </profile-dropdown>
        </portal>
      </div>
      <router-link :to="`/user/${userName}`" class="profile-responsive">
        <div class="profile-picture-container">
          <img v-if="profilePic" :src="profilePic" alt="Profile Picture"/>
          <font-awesome-icon v-else :icon="['fa', 'user-circle']" size="2x"
            :style="{ color: 'lightgray' }"/>
        </div>
      </router-link>
    </div>
    <div v-else class="unauthenticated-container">
      <router-link class="header-tabs" to="/event/new/edit">
        <span>Create Event</span>
      </router-link>
      <button class="login" aria-label="Sign In" @click="authenticate()">Sign In</button>
      <portal to="dialogs" v-if="isLoginDialogVisible">
        <auth-dialog></auth-dialog>
      </portal>
    </div>
    <portal to="dropdowns" v-if="showResponsiveDropdown">
      <responsive-dropdown @hideDropdown="showResponsiveDropdown=false">
      </responsive-dropdown>
    </portal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AuthDialog from '@/components/auth/AuthDialog.vue';
import SearchBar from '@/components/SearchBar.vue';
import ProfileDropdown from '@/components/dropdowns/ProfileDropdown.vue';
import ResponsiveDropdown from '@/components/dropdowns/ResponsiveDropdown.vue';

export default {
  name: 'YoupairedHeader',
  components: {
    AuthDialog,
    SearchBar,
    ProfileDropdown,
    ResponsiveDropdown,
  },
  data() {
    return {
      showProfileDropdown: false,
      showResponsiveDropdown: false,
    };
  },
  computed: {
    ...mapState('auth', ['isLoginDialogVisible', 'authenticated']),
    ...mapState('user', ['profilePic', 'userName']),
  },
  methods: {
    ...mapActions('auth', ['authenticate']),
  },
};

</script>
<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.container {
  position: fixed;
  width: 100%;
  background-color: $header-background;
  height: 4rem;
  display: flex;
  align-items: center;
  font-size: 1rem;
  box-shadow: 0 0.05rem 0.1rem $header-theme;
  transition: all 0.6s ease-out;
  z-index: 30;
}

.unauthenticated-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: auto;
}

.authenticated-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  list-style: none;
}

.header-tabs {
  vertical-align: middle;
  margin: 0 1rem 0 1rem;
  text-align: center;
  text-decoration: none;
  color: black;
  cursor: pointer;
}

li {
  cursor: pointer;
}

.header-tabs > span:hover, .selected-tab {
  padding-bottom: 0.5rem;
  border-bottom: 0.15rem solid $router-link;
}

.site-logo > img {
  margin: 0.25rem 1rem 0 1rem;
  width: 9rem;
}

.login {
  padding: 0.5rem 0.75rem;
  margin-right: 2rem;
  border-radius: 0.2rem;
  color: #fff;
  background-color: $login-background;
  font-size: 1rem;
  border:none;
  font-weight: 700;
  white-space: nowrap;
  letter-spacing: .025rem;
  cursor: pointer;
  text-decoration: none;
  box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);
}

.login:hover {
  background-color: $login-hover;
  border-color: $login-hover;
}

.profile {
  padding: 0.25rem 1rem 0 0;
  margin-right: 0.5rem;
  display: flex;
  &:hover {
    opacity: 0.8;
  }
  cursor: pointer;
}

.profile-picture-container {
  display: flex;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  overflow: hidden;
  border-radius: 50%;
}

.profile-picture-container > img {
  margin: 0 auto;
  width: 100%;
  height: 100%;
}

.user-name {
  padding: 0.75rem 0.5rem 0 0;
}

.create {
  margin: 0 0 0 auto;
}

.responsive-angle-down-icon {
  margin-left: 0.5rem;
}

.responsive-icon-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-left: 1rem;
}

@media screen and (min-width: 815px) {
  .responsive-angle-down-icon {
    display: none;
  }
  .profile-responsive {
    display: none;
  }

  .responsive-icon-container {
    display: none;
  }
}

@media screen and (max-width: 814px) {
  .site-logo {
    display: none;
  }

  .header-tabs, .profile {
    display: none;
  }

  .profile-responsive {
    margin-left: auto;
    margin-right: 0.5rem;
  }

  .container {
    justify-content: flex-start;
  }
}
</style>
